export default __webpack_public_path__ + "static/media/transaction.fb97a779.svg";